"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestFault = exports.RequestError = void 0;
class RequestError extends Error {
    constructor(message, fault) {
        super(message);
        this.fault = fault;
        this.name = 'RequestError';
    }
}
exports.RequestError = RequestError;
class RequestFault {
    constructor(params = {}) {
        this.code = -1;
        this.message = '';
        this.stackTrace = '';
        if (params.code)
            this.code = params.code;
        if (params.message)
            this.message = params.message;
        if (params.stackTrace)
            this.stackTrace = params.stackTrace;
    }
    slipstreamWrite(writer) {
        writer.writeIntegerValue(this.code);
        writer.writeStringValue(this.message || '');
        writer.writeStringValue(this.stackTrace || '');
        if (this.innerFault) {
            writer.writeBooleanValue(true);
            this.innerFault.slipstreamWrite(writer);
        }
        else {
            writer.writeBooleanValue(false);
        }
    }
    slipstreamRead(reader) {
        this.code = reader.readIntegerValue();
        this.message = reader.readStringValue();
        this.stackTrace = reader.readStringValue();
        if (reader.readBooleanValue()) {
            this.innerFault = new RequestFault();
            this.innerFault.slipstreamRead(reader);
        }
    }
}
exports.RequestFault = RequestFault;
